import type { ReactNode } from 'react'

type DataTableProps = {
  children: ReactNode
  className?: string
  wrapClassName?: string
  caption?: string
}

export const DataTable = ({ children, className, wrapClassName, caption }: DataTableProps) => (
  <div className={['market-table-wrap', wrapClassName].filter(Boolean).join(' ')}>
    <table className={['market-table', className].filter(Boolean).join(' ')}>
      {caption ? <caption className="visually-hidden">{caption}</caption> : null}
      {children}
    </table>
  </div>
)
